import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { IoSave } from 'react-icons/io5'
import { Link, useParams } from 'react-router-dom'
import { FcNook } from 'react-icons/fc'
import {
    AlertType, classDivBackground, classInput, classInputDark, classLabel, classLabelDark, classBt, classDivBody, classbtAzul, SubGrupoDespesa,
    grupoDespesaAttributes, classBorderLabelDark, classWeigthBt, barraVermelhoAzul, bgBlue, bgRed, focusRed, focusLabelRed, classbtColunasVermelho,
    classbtCinzaClaro, classDtCriarAtt, classUserCriarAtt, InputsRefs
} from '../../Utils/Types'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import moment from 'moment'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faClipboardList, faFolder } from '@fortawesome/free-solid-svg-icons'
import { Icone } from '../../Components/Icones/Index'
import { GrupoDespesaService } from './GrupoDespesaService'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { ModalSGrupoDespesa } from '../../Components/Modal/modalSGrupoDesp'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle, FaVideo } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const GrupoDespesaNew = () => {

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },

    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'descricao', erro: false }, // Posição 0 do Array.    
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idgDespesa } = useParams<string>()
    const [id, setId] = useState(0)
    const [gDespAttributes, setGDespAttributes] = useState<grupoDespesaAttributes>()

    const [descricao, setDescricao] = useState("")
    const [descricaoCopia, setDescricaoCopia] = useState("")
    const [idSgrupoDespesa, setIdSgrupoDespesa] = useState(0)
    const [sGrupoDesp, setSGrupoDesp] = useState<SubGrupoDespesa[]>([])
    const [classificacao, setclassificacao] = useState("")

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // ---------- MODALS --------------------------------------------------------------
    const [visible_Modal_SubGrupoDesp, setVisible_Modal_SubGrupoDesp] = useState(false)
    const [visible_modal_additem, setVisible_modal_additem] = useState(false)

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxSubGrupoDesp, setVisibleSearchBoxSubGrupoDesp] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const getAttributes = async () => {
        setLoading(true)

        try {

            const grupoDespesaAttributes = await GrupoDespesaService.GetAttributes(idgDespesa)
            setGDespAttributes(grupoDespesaAttributes.data)

            const sGruposList = grupoDespesaAttributes.data.subGrupoDespesa.filter((item: any) => item.id === grupoDespesaAttributes.data.grupoDespesa?.id)
            if (sGruposList && sGruposList.length > 0) {
                setIdSgrupoDespesa(sGruposList[0].id)
            }

            if (grupoDespesaAttributes.data && idgDespesa) {

                setId(grupoDespesaAttributes.data.grupoDespesa.id || 0)
                setDescricao(grupoDespesaAttributes.data.grupoDespesa.description || '')
                setDescricaoCopia(grupoDespesaAttributes.data.grupoDespesa.description || '')
                setIdSgrupoDespesa(grupoDespesaAttributes.data.grupoDespesa.id_sgrupo_despesa || 0)
                setclassificacao(grupoDespesaAttributes.data.grupoDespesa.classificacao || '')

                setUserCriador(grupoDespesaAttributes.data.grupoDespesa.name_user_insert || '')
                setUsertAtt(grupoDespesaAttributes.data.grupoDespesa.name_user_last_update || '')

                if (grupoDespesaAttributes.data.grupoDespesa.dt_cadastro) {
                    const dataFormatadaCriacao = moment(grupoDespesaAttributes.data.grupoDespesa.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (grupoDespesaAttributes.data.grupoDespesa.dt_last_update) {
                    const dataFormatadaAtt = moment(grupoDespesaAttributes.data.grupoDespesa.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

            }

            if (grupoDespesaAttributes.data) {
                setSGrupoDesp([...grupoDespesaAttributes.data.subGrupoDespesa])
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        getAttributes()
        inputFocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        searchBoxFocus()
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const descricaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescricao(e.target.value)
    }

    const classificacaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setclassificacao(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- SUBGRUPO DESPESA ----------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearSGrupoDespSelecionada = useCallback(() => {
        const newSGrupoDespList = [...gDespAttributes?.subGrupoDespesa || []]
        setSGrupoDesp(newSGrupoDespList)
        setIdSgrupoDespesa(0)

        setVisibleSearchBoxSubGrupoDesp(false)
        boxFocusSubGrupoDesp()
    }, [gDespAttributes?.subGrupoDespesa])

    const handleFilterSGrupoDespClick = useCallback(async (description: string) => {

        if (description === "") {

            const newSGrupoDespList = [...gDespAttributes?.subGrupoDespesa || []]
            setSGrupoDesp(newSGrupoDespList || [])

        } else {

            const newSGrupoDespList = [...gDespAttributes?.subGrupoDespesa || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setSGrupoDesp(newSGrupoDespList || [])
        }

    }, [gDespAttributes?.subGrupoDespesa])

    const handleSGrupoDespSelectClick = useCallback((v: SubGrupoDespesa) => {

        if (v) {
            const newSGrupoDespList = [...gDespAttributes?.subGrupoDespesa || []]
            setSGrupoDesp(newSGrupoDespList)
            setIdSgrupoDespesa(v.id)
        }

        setVisibleSearchBoxSubGrupoDesp(false)
        boxFocusSubGrupoDesp()
    }, [gDespAttributes?.subGrupoDespesa])

    const updateIdSubGrupoDesp = useCallback((id: number) => {
        setIdSgrupoDespesa(id)
    }, [gDespAttributes?.subGrupoDespesa])

    const updateDadosList = useCallback(async () => {
        const grupoDespesaAttributes = await GrupoDespesaService.GetAttributes(idgDespesa)
        setGDespAttributes(grupoDespesaAttributes.data)

        if (grupoDespesaAttributes) {
            setSGrupoDesp([...grupoDespesaAttributes.data.subGrupoDespesa])
        }

        boxFocusSubGrupoDesp()
        setVisibleSearchBoxSubGrupoDesp(false)

        setVisible_Modal_SubGrupoDesp(false)
    }, [idgDespesa])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- GRUPO DESPESA -------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novoGrupoDespesa = () => {
        setId(0)
        setDescricao("")
        setIdSgrupoDespesa(0)
        setclassificacao("")

        setDtCriador('')
        setDtAtt('')
        setUserCriador('')
        setUsertAtt('')

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        searchBoxFocus()

        redefinirCampos()
        inputFocus()
    }

    const handleSaveGrupoDespesa = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }
        setLoading(true)
        searchBoxFocus()

        try {

            let gDespesa: any = {
                description: descricao,
                id_sgrupo_despesa: idSgrupoDespesa,
                classificacao: classificacao,
            }

            if (id > 0) {
                gDespesa.id = id
            }

            const resp = await GrupoDespesaService.Save(gDespesa)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios()

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados do grupo de despesa atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setDescricaoCopia(resp.data.grupo_despesa.descricao)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                redefinirCampos()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar o grupo de despesa. Por favor, tente novamente` : `Não foi possível salvar o grupo de despesa. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }


    }

    const checkDadosObrigatorios = (): boolean => {

        if (descricao.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'descricao' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {

        let fieldsM: CampoObrigatorio[] = [
            { campo: 'descricao', erro: false }, // Posição 0 do Array.    
        ]

        setCamposObrigatorios(fieldsM)

    }

    const inputFocus = () => {
        const inputElement = document.getElementById("descricao")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- MODAL SUBGRUPO DESPESA ----------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleAbrirModalSGrupoDesp = useCallback(() => {
        setVisible_Modal_SubGrupoDesp(true)
        setVisible_modal_additem(true)
        setVisible(false)
    }, [])

    const fecharModalSubGrupoDesp = useCallback(() => {
        setVisible_Modal_SubGrupoDesp(false)
        setVisible_modal_additem(false)

        boxFocusSubGrupoDesp()
        inputFocusSubGrupoDesp()
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        descricao: useRef(null),
        subGrupoDesp: useRef(null),
        classificacao: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            setVisibleSearchBoxSubGrupoDesp(false)

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 1) {
                setVisibleSearchBoxSubGrupoDesp(true)
                inputFocusSubGrupoDesp()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchSubGrupoDesp = document.getElementById('inputSearchBox-subGrupoDesp') as HTMLInputElement

                if (event.key === 'Tab' && tabs[0].active && document.activeElement === inputSearchSubGrupoDesp) {
                    inputsRefs['classificacao'].current?.focus()
                    setVisibleSearchBoxSubGrupoDesp(false)
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }

    }, [tabs])

    const searchBoxFocus = () => {
        setVisibleSearchBoxSubGrupoDesp(false)
    }

    // GRUPODESPESA ---------------------------------------------------
    const boxFocusSubGrupoDesp = () => {
        // Move o foco para o input correspondente à chave 'subGrupoDesp'.
        inputsRefs['subGrupoDesp'].current?.focus()
    }

    const clickSearchBoxSubGrupoDesp = useCallback(() => {
        setVisibleSearchBoxSubGrupoDesp((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Foca no SearchBoxSubGrupoDesp
                inputFocusSubGrupoDesp()
            }
            return newState
        })
        boxFocusSubGrupoDesp()
    }, [])

    const inputFocusSubGrupoDesp = () => {
        let inputSearch = document.getElementById(`inputSearchBox-subGrupoDesp`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && (tabs[1].active)) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    const btNovoVisible = parseInt(idgDespesa || '') > 0 ? 'invisible hidden' : 'visible'

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] flex items-center my-3 px-2`}>
                            <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all mx-2`}>{parseInt(idgDespesa || '') || id > 0 ? `Editar - Grupo de Despesa - ${descricaoCopia}` : `Cadastro - Grupo de Despesa`}</span>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} shadow-md shadow-blue-600`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`w-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados do Grupo de Despesa</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700 w-[70%]`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-5`}>
                                        <div className={`${barraVermelhoAzul} ${descricao != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.descricao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'descricao')} id="descricao" className={`${classInput} ${classInputDark} ${descricao != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={descricao} onFocus={searchBoxFocus} onChange={descricaoChange} />
                                        <label htmlFor="descricao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${descricao != '' ? '' : focusLabelRed}`}>Descrição</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4`}>

                                        <div ref={inputsRefs['subGrupoDesp']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'subGrupoDesp')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={sGrupoDesp}
                                            idRegistro={idSgrupoDespesa || undefined}
                                            label='SubGrupo Despesa'
                                            componentId='subGrupoDesp'
                                            visibleAddItem={visible_modal_additem}
                                            visibleTAB={visibleSearchBoxSubGrupoDesp}
                                            setDataClick={handleSGrupoDespSelectClick}
                                            clearDataClick={handleClearSGrupoDespSelecionada}
                                            filterDataClick={handleFilterSGrupoDespClick}
                                            additem={handleAbrirModalSGrupoDesp}
                                            clicado={clickSearchBoxSubGrupoDesp}

                                        />

                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-3`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.classificacao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'classificacao')} id="classificacao" className={`${classInput} ${classInputDark} `} type='text' inputMode='text' maxLength={20} placeholder=" " autoComplete='off' value={classificacao} onFocus={searchBoxFocus} onChange={classificacaoChange} />
                                        <label htmlFor="classificacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Classificação</label>
                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/grupoDespesa" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={novoGrupoDespesa} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveGrupoDespesa} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idgDespesa || '0') > 0 || id != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}
                                    </button>

                                </div>
                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoGrupDesp" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoGrupDesp" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoGrupDesp" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoGrupDesp" className={`${classDtCriarAtt}`}>{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttGrupDesp" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttGrupDesp" className={`${classDtCriarAtt}`}>{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttGrupDesp" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttGrupDesp" className={`${classDtCriarAtt}`}>{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <ModalSGrupoDespesa
                    setIdSubGrupoDesp={updateIdSubGrupoDesp}
                    visible={visible_Modal_SubGrupoDesp}
                    modalConfirmClick={updateDadosList}
                    closeModal={fecharModalSubGrupoDesp}
                />

                {modalTutorialVisible &&
                    <ModalTutorial
                        linkVideo='/tutorial_grupoDespesa.mp4'
                        title='Como cadastrar um grupo de despesa'
                        visible={modalTutorialVisible}
                        onCloseClick={() => setModalTutorialVisible(false)}
                    />
                }
            </div>

        </Template>
    )
}